import React, { JSX } from 'react';
import PackageBestPriceDetails, {
  PackageBestPriceDetailsProps
} from '../../SubModules/PackageDetails/PackageBestPriceDetails';
import BestPriceAvailabilityProps from '../BestPriceAvailability/externals';
import ContentContainer from '../../Components/ContentContainer/ContentContainer';
import { Col, Row } from 'reactstrap';
import FixedElementScroll from '../../Components/FixedElementScroll/FixedElementScroll';
import PackageStore from './PackageStore';
import { observer } from 'mobx-react';
const BestPriceAvailability = React.lazy(
  () => import('../BestPriceAvailability/BestPriceAvailability')
);
const BestPriceListSelections = React.lazy(
  () => import('../BestPriceListSelections/BestPriceListSelections')
);

const BestPrice = observer(
  (
    props: PackageBestPriceDetailsProps & BestPriceAvailabilityProps & { store: PackageStore }
  ): JSX.Element => {
    const {
      onSelect,
      goBackToList,
      bestPriceMaxDateRangeSpan,
      showLabels,
      destinationMandatory,
      endDateMandatory,
      availabilitySortingActive,
      onBestPriceAvailabilitySelect,
      showMealDetails,
      minSelectableChildAge,
      noDatePickerOverflow,
      showCharacteristics,
      changeOnBlur,
      onlyAdultSelect,
      bestPriceStickySearch,
      bestPriceRenderSearchContent,
      bestPriceDesktopSearchCollapse,
      bestPriceIsStickyListener,
      onBestPriceSearchChange,
      bestPriceStickyOffset,
      bestPriceSubmitOnChange,
      widgetClickable,
      item,
      hideDetailBackButton,
      packageStore,
      ExternalBestPriceDetailsContent,
      bestPriceListSelectionsMode,
      store,
      includeCheapestFlightInRoomPrice,
      splitRequiredComponentPricePerPerson,
      withRoomCountSelector,
      subType,
      afterSearch,
      bestPriceShowDirectFlightsOnlyFilter,
      internalFlightLogo,
      showInternalFlightLogo,
      scrollOnInitialSearch,
      useGeoUnitTwoColumnStyling
    } = props;

    return (
      <>
        <Row className="best-price-wrapper flex-wrap mb-4">
          <Col xs={12} lg={!!ExternalBestPriceDetailsContent?.PriceDetails ? 9 : 12}>
            {!!ExternalBestPriceDetailsContent ? (
              <ExternalBestPriceDetailsContent.MainContent
                item={item}
                searchParams={packageStore.searchParams}
              />
            ) : (
              <PackageBestPriceDetails
                item={item}
                goBackToList={goBackToList}
                showMealDetails={showMealDetails}
                showCharacteristics={showCharacteristics}
                hideDetailBackButton={hideDetailBackButton}
                onSelect={(s): void => {
                  if (onSelect) {
                    onSelect(s);
                  }
                }}
              />
            )}
          </Col>
          {!!ExternalBestPriceDetailsContent?.PriceDetails && (
            <FixedElementScroll offset={20}>
              <div className="fixed-scroll-element-container">
                <ExternalBestPriceDetailsContent.PriceDetails
                  item={item}
                  searchParams={store.searchParams}
                />
              </div>
            </FixedElementScroll>
          )}
        </Row>
        <ContentContainer className="best-price__list-selections__container hide-in-print">
          {bestPriceListSelectionsMode ? (
            <BestPriceListSelections
              item={item}
              bestPriceMaxDateRangeSpan={bestPriceMaxDateRangeSpan}
              showLabels={showLabels}
              withDateRangePicker
              destinationMandatory={destinationMandatory}
              endDateMandatory={endDateMandatory}
              packageStore={store}
              availabilitySortingActive={availabilitySortingActive}
              onBestPriceAvailabilitySelect={onBestPriceAvailabilitySelect}
              minSelectableChildAge={minSelectableChildAge}
              noDatePickerOverflow={noDatePickerOverflow}
              changeOnBlur={changeOnBlur}
              onlyAdultSelect={onlyAdultSelect}
              bestPriceStickySearch={bestPriceStickySearch}
              bestPriceRenderSearchContent={bestPriceRenderSearchContent}
              bestPriceDesktopSearchCollapse={bestPriceDesktopSearchCollapse}
              bestPriceIsStickyListener={bestPriceIsStickyListener}
              widgetClickable={widgetClickable}
              onBestPriceSearchChange={a =>
                onBestPriceSearchChange &&
                onBestPriceSearchChange({
                  bestPriceSearchStore: a.bestPriceSearchStore,
                  bestPriceStore: a.bestPriceStore,
                  packageStore: store,
                  changeType: a.changeType
                })
              }
              bestPriceStickyOffset={bestPriceStickyOffset}
              bestPriceSubmitOnChange={bestPriceSubmitOnChange}
              includeCheapestFlightInRoomPrice={includeCheapestFlightInRoomPrice}
              splitRequiredComponentPricePerPerson={splitRequiredComponentPricePerPerson}
              subType={subType}
              withRoomCountSelector={withRoomCountSelector}
              afterSearch={afterSearch}
              bestPriceShowDirectFlightsOnlyFilter={bestPriceShowDirectFlightsOnlyFilter}
              internalFlightLogo={internalFlightLogo}
              showInternalFlightLogo={showInternalFlightLogo}
              scrollOnInitialSearch={scrollOnInitialSearch}
              useGeoUnitTwoColumnStyling={useGeoUnitTwoColumnStyling}
            />
          ) : (
            <BestPriceAvailability
              item={item}
              bestPriceMaxDateRangeSpan={bestPriceMaxDateRangeSpan}
              showLabels={showLabels}
              withDateRangePicker
              destinationMandatory={destinationMandatory}
              endDateMandatory={endDateMandatory}
              packageStore={store}
              availabilitySortingActive={availabilitySortingActive}
              onBestPriceAvailabilitySelect={onBestPriceAvailabilitySelect}
              minSelectableChildAge={minSelectableChildAge}
              noDatePickerOverflow={noDatePickerOverflow}
              changeOnBlur={changeOnBlur}
              onlyAdultSelect={onlyAdultSelect}
              bestPriceStickySearch={bestPriceStickySearch}
              bestPriceRenderSearchContent={bestPriceRenderSearchContent}
              bestPriceDesktopSearchCollapse={bestPriceDesktopSearchCollapse}
              bestPriceIsStickyListener={bestPriceIsStickyListener}
              widgetClickable={widgetClickable}
              onBestPriceSearchChange={a =>
                onBestPriceSearchChange &&
                onBestPriceSearchChange({
                  bestPriceSearchStore: a.bestPriceSearchStore,
                  bestPriceStore: a.bestPriceStore,
                  packageStore: store,
                  changeType: a.changeType
                })
              }
              bestPriceStickyOffset={bestPriceStickyOffset}
              bestPriceSubmitOnChange={bestPriceSubmitOnChange}
              withRoomCountSelector={withRoomCountSelector}
              splitRequiredComponentPricePerPerson={splitRequiredComponentPricePerPerson}
            />
          )}
        </ContentContainer>
      </>
    );
  }
);

export default BestPrice;
